import * as rootTypes from '@/store/mutation-types'
import * as types from './mutation-types'

export default store => {
  store.subscribe(mutation => {
    if (mutation.type === rootTypes.SET_STORE) {
      store.commit('orderModule/' + types.CLEAN_STATE)
    }
  })
}
